export default __webpack_public_path__ + "static/media/Contract.0e8f0770.svg";